import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-heart",
  "use": "icon-heart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-heart\">\n<path d=\"M19.89 4.67997C18.78 3.64997 17.38 3.14997 15.95 3.24997C14.2 3.37997 12.86 4.49997 12 5.48997C11.15 4.49997 9.81 3.37997 8.06 3.24997C6.62 3.14997 5.23 3.64997 4.12 4.67997C2.93 5.77997 2.25 7.31997 2.25 8.89997C2.25 10.41 2.84 11.81 3.97 12.93L11.47 20.53C11.61 20.67 11.8 20.75 12 20.75C12.2 20.75 12.39 20.67 12.53 20.53L20.03 12.93C21.15 11.81 21.75 10.41 21.75 8.89997C21.75 7.31997 21.07 5.77997 19.89 4.67997Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol